import React from 'react';
import { GlobalProgramBasicInfoComponent } from './global-program-basic.component';
import { UploadMedia } from '../../../../../common/components/common/upload-media';
import OneProgramValuesComponent from './global-program-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';


export const GlobalProgramComponent = ({ selectedProgramValues, id, onFormItemChange, selectedGlobalPrograms, columnDefs, handleEdit, additionButtons, handleDelete, onInnerBasicFormChange, back, handleFormSubmit }: any) => {

    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '', //not used
        });
    };

    const tabItems = [
        {
            id: 1,
            title: 'Basic-Info',
            component: (
                <GlobalProgramBasicInfoComponent
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedGlobalPrograms={selectedGlobalPrograms}
                />
            ),
            isVisible: true,
        },
        // {
        //     id: 2,
        //     title: 'Media',
        //     component:
        //         <UploadMedia
        //             handleInnerFormChange={handleInnerMediaFormChange}
        //             mediaFilesList={selectedGlobalPrograms?.MediaMappings?.MediaFiles}
        //             ownerTypeId={1007}
        //             ownerId={id}
        //             folderName={'oneprogram'}
        //         />,
        //     isVisible: true,
        // },
        {
            id: 5,
            title: 'One program',
            component:
                <OneProgramValuesComponent
                    handleDelete={handleDelete}
                    additionButtons={additionButtons}
                    handleEdit={handleEdit}
                    columnDefs={columnDefs}
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedProgramValues={selectedProgramValues}
                />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
              
            </div>
        </div>
    )
}
export default GlobalProgramComponent;
